import { Frame, State } from 'features/Frames/types';

export const framesByStatus = (status: string, frames: Frame[]) => {
  if (status) {
    const key: State = State[status as keyof typeof State];
    return frames.filter((frame) => frame.status?.state === key);
  }
  return frames;
};
